import * as moment from 'moment';
import { ISearchForList } from "@nkr/models/index";
import { BillableNephrectomyStatus } from "@nkr/enums/index";

interface IProps {
    centerId: number,
    data: ISearchForList,
    onViewCharges: (id: number, action: string) => void
}

const SearchRow = (props: IProps) => {
    const handleViewCharges = () => {
        let { recipientCenterId, statusId } = props.data;
        let action = "view-edit";

        if (props.centerId == recipientCenterId) {
            if (statusId == BillableNephrectomyStatus.SentToRecipientCenter) {
                action = "view-charges";
            }
        }

        props.onViewCharges(props.data.donorId, action);
    };

    const getStatusDescription = () => {
        let { donorCenterId, donorCenterAlias, recipientCenterAlias, statusId } = props.data;

        switch (statusId) {
            case BillableNephrectomyStatus.SentToRecipientCenter:
                if (props.centerId == donorCenterId) {
                    return `Submitted to ${recipientCenterAlias}`;
                } else {
                    return `Awaiting Response from ${recipientCenterAlias}`;
                }

            case BillableNephrectomyStatus.AcceptedByRecipientCenter:
                return `Accepted by ${recipientCenterAlias}`;

            case BillableNephrectomyStatus.AcceptedByRecipientCenterDueToNonResponse:
                return `Accepted Due To No Response by ${recipientCenterAlias}`;

            case BillableNephrectomyStatus.DisputedByRecipientCenter:
                return `Disputed by ${recipientCenterAlias}`;

            case BillableNephrectomyStatus.PaymentSentToDonorCenter:
                return `Payment Sent to ${donorCenterAlias}`;

            case BillableNephrectomyStatus.PaymentReceivedByRecipientCenter:
                return `Payment Received by ${recipientCenterAlias}`;

            case BillableNephrectomyStatus.BilledManually:
                return "Billed Manually";
        }

        return "Unknown";
    };

    const getActionDescription = () => {
        let { recipientCenterId, statusId } = props.data;
        let action = "Review Charges";

        if (props.centerId == recipientCenterId && statusId == BillableNephrectomyStatus.SentToRecipientCenter)
            action = "Accept/Dispute Charges";

        return action;
    };

    const item = props.data;
    const status = getStatusDescription();
    const action = getActionDescription();

    return (
        <tr>
            <td>{moment(item.transplantDate).calendar()}</td>
            <td>{item.chainId}/{item.clusterNumber}/{item.positionNumber}</td>
            <td>{item.donorCenterAlias} {item.donorRdnCenterAlias != '' ? <span style={{ color: 'darkred' }}>({item.donorRdnCenterAlias})</span> : null}</td>
            <td>{item.donorAlias}</td>
            <td>{item.recipientCenterAlias}</td>
            <td>{item.recipientAlias}</td>
            <td>{item.claimType}</td>
            <td>{item.dateSubmittedToRecipientCenter}</td>
            <td>{item.acceptRejectDeadline}</td>
            <td>{item.dateAcceptedByRecipientCenter}</td>
            <td>{status}</td>
            <td>
                {item.statusId != BillableNephrectomyStatus.BilledManually && (
                    <button className="btn btn-primary btn-xs" onClick={handleViewCharges}>{action}</button>
                )}
            </td>
        </tr>
    );
}

export default SearchRow;